import { CardActionArea } from '@mui/material';
import { styled } from '@mui/material/styles';
import { React } from "react";
import { useNavigate } from 'react-router';

const CardStyled = styled(CardActionArea)(() => ({
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
    padding: '10px',
    fontFamily: 'Jost',
    color: 'white',
    display: 'flex',
    marginTop: '1rem',
    alignContent: 'start',
    justifyContent: 'flex-start',
    width: '90%',
}));

const Label = styled('span')(() => ({
    fontWeight: '500',
    fontSize: '1.5rem',
}));

const Subtitle = styled('span')(() => ({
}));

const IconContainer = styled('span')(() => ({
    padding: '1rem 1rem',
}));

const TextContainer = styled('span')(() => ({
    padding: '1rem 1rem',
}));

function DashboardMenuItem({ color, icon, label, subtitle, link }) {
    const navigate = useNavigate();
    const redirect = () => {
        navigate(link);
    };

    return (
        <CardStyled style={{ background: color }} onClick={redirect}>
            <IconContainer>
                {icon}
            </IconContainer>
            <TextContainer>
                <Label>{label}</Label>
                <br></br>
                <Subtitle>{subtitle}</Subtitle>
            </TextContainer>
        </CardStyled>
    );
}

export default DashboardMenuItem;